import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { useLang } from "../../i18n/LanguageContext";

export const FinalCTA = () => {
  const { t, path } = useLang();
  return (
    <section className="bg-[#092B35] py-32 md:py-44 relative overflow-hidden border-t border-white/5" data-testid="home-final-cta">
      <div className="absolute inset-0 film-lines opacity-50" aria-hidden="true" />
      <div className="absolute -top-32 right-1/4 w-[500px] h-[260px] rounded-full bg-[#19C7C1]/8 blur-[110px]" aria-hidden="true" />
      <div className="relative max-w-[900px] mx-auto px-6 md:px-10 text-center">
        <Reveal>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light tracking-tight text-white leading-[1.12]">
            {t.finalCta.title}
          </h2>
          <p className="mt-7 text-base md:text-lg text-slate-400 leading-relaxed max-w-xl mx-auto">
            {t.finalCta.copy}
          </p>
          <Link to={path("/contact")} className="btn-primary mt-11 inline-flex" data-testid="final-cta-btn">
            {t.finalCta.cta}
            <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};
